import { Alert, AspectRatio, Group } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera, faRotateRight, faXmark } from '@fortawesome/free-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Button } from '../Button';
import { useFaceCamera } from './useFaceCamera';

export function FaceCamera({ onCapture, onCancel, disabled = false }: {
  onCapture: (image: string) => Promise<boolean>; onCancel: () => void; disabled?: boolean;
}) {
  const state = useFaceCamera(onCapture);
  return <section aria-label="צילום פנים" dir="rtl">
    {state.error && <Alert color="orange">{state.error}</Alert>}
    <AspectRatio ratio={4 / 3}>
      <video ref={state.video} aria-label="מצלמה לאימות פנים" autoPlay muted playsInline onCanPlay={state.onReady}
        style={{ width: '100%', height: '100%', objectFit: 'cover', transform: 'scaleX(-1)' }} />
    </AspectRatio>
    <Group justify="center" mt="sm" wrap="wrap">
      <Button variant="confirm" onClick={state.capture} disabled={disabled || !state.ready} loading={state.busy} ariaLabel="צלם ואמת פנים">
        <FontAwesomeIcon icon={faCamera as IconProp} /> צלם ואמת
      </Button>
      {state.error && <Button variant="save" onClick={state.retry} disabled={state.busy} ariaLabel="הפעל מצלמה שוב">
        <FontAwesomeIcon icon={faRotateRight as IconProp} /> נסה שוב
      </Button>}
      <Button variant="cancel" onClick={onCancel} disabled={state.busy} ariaLabel="בטל צילום פנים">
        <FontAwesomeIcon icon={faXmark as IconProp} /> ביטול
      </Button>
    </Group>
  </section>;
}